import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-web-page',
  templateUrl: './web-page.component.html',
  styleUrls: ['./web-page.component.css']
})
export class WebPageComponent implements OnInit {
  title : string;
  facts ;

  constructor(private titleService: Title,private translateService : TranslateService) { 
    this.title = this.translateService.instant("web design")
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);

    this.facts = [
      {icon: "./../../../assets/images/imagination.png", title: this.translateService.instant("Imagine as we perform"), content: this.translateService.instant("The CodeRoots team does not stand anything in front of it, so we have no impossible or limits to achieve what is in your imagination. All this is the result of years of experience that we put in your hands to implement your software project.")},
      {icon: "./../../../assets/images/shield.png", title: this.translateService.instant("Glitch-free software"), content: this.translateService.instant("We are always keen to adopt modern technologies in securing and protecting the software files that we offer, and we make sure that they are free from loopholes, out of our concern for customers’ websites. We test the software well before launching it.")},
      {icon: "./../../../assets/images/ok.png", title: this.translateService.instant("future proposals"), content: this.translateService.instant("We are always keen to provide important and future proposals for your software project that increase the required results for software projects in various fields. The success of your software project is our success.")}
    ];
  }

}
